
export enum UserRole {
  MASTER_ADMIN = 'MASTER_ADMIN',
  ADMIN = 'ADMIN',
  REPRESENTATIVE = 'REPRESENTATIVE',
  GUEST = 'GUEST', // Added for public access
}

export interface User {
  id: string; // Firebase UID
  username: string; // Used for email construction (username@mahallu.app)
  role: UserRole;
  name: string;
  visibleSections?: string[]; // IDs of allowed sections
}

export interface SurveySection {
  id: string;
  label: string;
  isRepeater?: boolean; // If true, allows adding multiple entries (like Family Members)
  order: number;
}

export interface DynamicQuestion {
  id: string;
  label: string;
  type: 'text' | 'number' | 'yesno' | 'dropdown' | 'textarea' | 'multiselect' | 'image' | 'date';
  section: string; // Changed from hardcoded union to string to support dynamic sections
  options?: string[]; // For dropdown/multiselect
  required?: boolean;
  dependsOn?: string; // ID of the question this depends on
  visibleIf?: string | boolean | string[]; // Value(s) that make this visible
}

export interface SurveyData {
  id: string;
  submittedBy: string;
  submittedAt: string;
  // We use index signature to allow dynamic section keys
  // Legacy support: sectionA, sectionB, etc. are still used as IDs
  [key: string]: any; 
}

export interface CardField {
  key: string;
  label: string;
  x: number;
  y: number;
  fontSize: number;
  color: string;
}

export interface CardTemplate {
  backgroundImage: string;
  fields: CardField[];
}